import { Chip, Fieldset } from '@audio-network/componentlibrary'
import { useTranslation } from 'next-i18next'
import React from 'react'
import { useCurrentRefinements, useMenu } from 'react-instantsearch'

import SelectFilter from '../SelectFilter/SelectFilter'
import keyFacets from './KeyFacets'
import styles from './KeyFilter.module.css'
import metreFacets from './MetreFacets'

const KeyFilter = (
	props: JSX.IntrinsicAttributes &
		React.ClassAttributes<HTMLDivElement> &
		React.HTMLAttributes<HTMLDivElement>
): JSX.Element => {
	const { t } = useTranslation(['search'])
	const { items, refine } = useMenu({
		attribute: 'IsMajorKeyMood',
		sortBy: ['name:desc'],
	})

	const { items: keyItems, refine: KeyRefine } = useCurrentRefinements()

	const cancelKeyFilters = (attribute: string): void => {
		const refinedItem = keyItems?.find((item) => item.attribute === attribute)
			?.refinements[0]

		if (refinedItem) {
			KeyRefine(refinedItem)
		}
	}

	const handleMajorKeyMoodChange = (value: string): void => {
		cancelKeyFilters('KeyStart')
		cancelKeyFilters('KeyFinish')

		refine(value === 'major' ? 'true' : 'false')
	}

	const clearMajorKeyMood = (): void => {
		const refinedItem = items?.find((item) => item.isRefined)
		if (refinedItem) {
			refine(refinedItem.value)
		}
	}

	const isMajorKeyMoodValue = keyItems?.find(
		(item) => item.attribute === 'IsMajorKeyMood'
	)?.refinements[0]?.value

	return (
		<div className={styles.keyMetre} {...props}>
			<Fieldset legend={t('key-mood')}>
				<div className={styles.keyMood}>
					<Chip
						content={t('key-mood-major')}
						pressed={isMajorKeyMoodValue === 'true'}
						onClick={() => handleMajorKeyMoodChange('major')}
						data-testid="major-chip"
					/>
					<Chip
						content={t('key-mood-minor')}
						pressed={isMajorKeyMoodValue === 'false'}
						onClick={() => handleMajorKeyMoodChange('minor')}
						data-testid="minor-chip"
					/>
				</div>
			</Fieldset>
			<div className={styles.openingClosingKey}>
				<SelectFilter
					attribute="KeyStart"
					curatedFacets={keyFacets}
					label={t('key-opening')}
					onSelect={clearMajorKeyMood}
				/>
				<SelectFilter
					attribute="KeyFinish"
					curatedFacets={keyFacets}
					label={t('key-closing')}
					onSelect={clearMajorKeyMood}
				/>
			</div>

			<div className={styles.divider} />
			<div className={styles.metre}>
				<SelectFilter
					attribute="Metre"
					curatedFacets={metreFacets}
					label={t('metre')}
				/>
			</div>
		</div>
	)
}

export default KeyFilter
